/**
 * Status color mappings for request statuses
 * Maps each status to appropriate color classes
 */
export const statusColors = {
  pending: 'bg-yellow-100 text-yellow-800',
  approved: 'bg-blue-100 text-blue-800',
  pending_receive: 'bg-blue-100 text-blue-800',
  in_progress: 'bg-purple-100 text-purple-800',
  completed: 'bg-green-100 text-green-800',
  cancelled: 'bg-red-100 text-red-800',
  rejected: 'bg-red-100 text-red-800'
};

/**
 * Gets the color classes for a status
 * @param {string} status - The status to get colors for
 * @returns {string} - The CSS classes for the status
 */
export const getStatusColors = (status) => {
  return statusColors[status] || 'bg-gray-100 text-gray-800';
};

export default statusColors;
